import React from 'react';
import { Clock } from '@phosphor-icons/react';
import {
  WORKOUT_TYPE,
  WORKOUT_CATEGORY,
  WORKOUT_CATEGORY_LABELS,
} from '../../../enums/programming';
import styles from './WorkoutBuilderModal.module.scss';

interface MetadataSectionProps {
  title: string;
  setTitle: (v: string) => void;
  workoutType: WORKOUT_TYPE;
  setWorkoutType: (v: WORKOUT_TYPE) => void;
  workoutCategory: WORKOUT_CATEGORY;
  setWorkoutCategory: (v: WORKOUT_CATEGORY) => void;
  estimatedDuration: number | undefined;
  tags: string;
  setTags: (v: string) => void;
  athleteNotes: string;
  setAthleteNotes: (v: string) => void;
  disableTypeChange?: boolean;
}

const MetadataSection: React.FC<MetadataSectionProps> = ({
  title,
  setTitle,
  workoutType,
  setWorkoutType,
  workoutCategory,
  setWorkoutCategory,
  estimatedDuration,
  tags,
  setTags,
  athleteNotes,
  setAthleteNotes,
  disableTypeChange = false,
}) => {
  return (
    <div className={styles.metaSection}>
      <div className={styles.fieldRow}>
        {/* Title */}
        <div className={styles.fieldGroup} style={{ flex: 2 }}>
          <label className={styles.label}>
            Titolo <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            className={styles.textInput}
            placeholder="Es. Scheda forza settimana 1"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {/* Type toggle */}
        <div className={styles.fieldGroup}>
          <label className={styles.label}>Tipo</label>
          <div className={styles.typeToggle}>
            <button
              type="button"
              disabled={disableTypeChange}
              className={`${styles.toggleBtn} ${
                workoutType === WORKOUT_TYPE.SINGLE_DAY
                  ? styles.toggleActive
                  : ''
              }`}
              onClick={() => !disableTypeChange && setWorkoutType(WORKOUT_TYPE.SINGLE_DAY)}
            >
              Giorno singolo
            </button>
            <button
              type="button"
              disabled={disableTypeChange}
              className={`${styles.toggleBtn} ${
                workoutType === WORKOUT_TYPE.MULTI_DAY
                  ? styles.toggleActive
                  : ''
              }`}
              onClick={() => !disableTypeChange && setWorkoutType(WORKOUT_TYPE.MULTI_DAY)}
            >
              Multi-giorno
            </button>
          </div>
        </div>

        {/* Workout Category */}
        <div className={styles.fieldGroup}>
          <label className={styles.label}>Categoria</label>
          <select
            className={styles.textInput}
            value={workoutCategory}
            onChange={(e) => setWorkoutCategory(e.target.value as WORKOUT_CATEGORY)}
          >
            {Object.entries(WORKOUT_CATEGORY_LABELS).map(([key, label]) => (
              <option key={key} value={key}>{label}</option>
            ))}
          </select>
        </div>

        {/* Estimated duration (read only) */}
        {estimatedDuration != null && (
          <div className={styles.fieldGroup}>
            <label className={styles.label}>Durata stimata</label>
            <div className={styles.durationBadge}>
              <Clock size={14} />
              ~{estimatedDuration} min
            </div>
          </div>
        )}
      </div>

      <div className={styles.fieldRow}>
        {/* Tags */}
        <div className={styles.fieldGroup} style={{ flex: 1 }}>
          <label className={styles.label}>
            Tag{' '}
            <span className={styles.hint}>(separati da virgola)</span>
          </label>
          <input
            type="text"
            className={styles.textInput}
            placeholder="Es. forza, upper, settimana1"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
          />
        </div>

        {/* Athlete notes */}
        <div className={styles.fieldGroup} style={{ flex: 2 }}>
          <label className={styles.label}>Note atleta</label>
          <textarea
            className={styles.textArea}
            placeholder="Istruzioni per l'atleta..."
            value={athleteNotes}
            onChange={(e) => setAthleteNotes(e.target.value)}
            rows={2}
          />
        </div>
      </div>
    </div>
  );
};

export default MetadataSection;
